import React from 'react'
import { Link } from 'react-router'

import logo from '@/assets/img/logo.svg'
import ExpandIcon from '@/components/layouts/DashboardLayout/components/DashboardSidebar/components/SidebarToggleButton/ExpandIcon'
import GlobalSearch from '@/components/misc/GlobalSearch/GlobalSearch'
import { Button } from '@/components/ui/button'
import { useSidebar } from '@/components/ui/sidebar'
import { useAddReferralsModal } from '@/hooks/useAddReferralsModal'
import { useHomeRoute } from '@/hooks/useHomeRoute'
import { useInviteToRqModal } from '@/hooks/useInviteToRqModal'
import { useIsCompanyUser } from '@/hooks/useIsCompanyUser'
import { useIsMinWidthMd } from '@/hooks/useIsMinWidthMd'
import { useIsVerySmallDevice } from '@/hooks/useIsVerySmallDevice'
import { cn } from '@/lib/utils'

const AppHeader: React.FC = () => {
  const isCompanyUser = useIsCompanyUser()
  const { toggleSidebar } = useSidebar()
  const isMinWidthMd = useIsMinWidthMd()
  const homeRoute = useHomeRoute()
  const inviteToRqModal = useInviteToRqModal()
  const isVerySmallDevice = useIsVerySmallDevice()
  const addReferralsModal = useAddReferralsModal()

  return (
    <header
      className="flex items-center justify-between gap-2 md:justify-start"
      style={
        isMinWidthMd
          ? {
              marginTop: '10px',
              paddingLeft: '30px',
            }
          : {
              // A little less marginTop for company users because we apply a
              // paddingTop on the global search icon on mobile
              marginTop: isCompanyUser ? '10px' : '16px',
              padding: '0 15px',
            }
      }
    >
      {!isMinWidthMd && (
        <Link to={homeRoute}>
          <img src={logo} style={{ width: '40px' }} alt="RQ" />
        </Link>
      )}

      <div
        className={cn(
          'flex flex-wrap items-center',
          isVerySmallDevice ? 'gap-2' : 'gap-4',
        )}
      >
        <div className="flex grow flex-wrap items-center gap-3">
          {isCompanyUser && !isVerySmallDevice && (
            <Button
              className="hidden shrink-0 sm:block"
              variant="success"
              onClick={() => inviteToRqModal.show()}
              size="sm"
            >
              Add Relationship
            </Button>
          )}

          {isCompanyUser && (
            <Button
              className="shrink-0"
              size="sm"
              onClick={() => addReferralsModal.showModal()}
            >
              Add Referrals
            </Button>
          )}
        </div>

        {isCompanyUser && (
          <div>
            <GlobalSearch />
          </div>
        )}

        <div
          className="text-dim hover-dim flex cursor-pointer items-center gap-2
            md:hidden"
          onClick={toggleSidebar}
        >
          <ExpandIcon />
          <span>Menu</span>
        </div>
      </div>
    </header>
  )
}

export default AppHeader
